import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import userServices from "../../services/user.services";
import center from '../../assets/images/icons/centerfff.svg'
import userIcon from '../../assets/images/icons/userfff.svg'
import xreyIcon from '../../assets/images/icons/xray-type-iconfff.svg'
import operatorIcon from '../../assets/images/icons/operator-iconfff.svg'
import doctorIcon from '../../assets/images/icons/doctorfff.svg'
import Loader from "../../components/common/Loader";



const Dashboard = () => {
    const navigate = useNavigate();
    const [dashboardData, setDashboardData] = useState('')
    const [loading, setLoading] = useState(true);

    const getData = async () => {
        try {
            setLoading(true);
            const result = await userServices.dashboardCounting();
            if (result.data.status === true) {
                console.log('data', result.data.data)
                setDashboardData(result.data.data)
            }
        } catch (error) {
            console.log('error', error)
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        getData();
    }, [])

    return (
        <React.Fragment>
            {/*page-wrapper*/}
            <div className="page-wrapper">
                {/*page-content-wrapper*/}
                <div className="page-content-wrapper">
                    <div className="page-content">
                        {loading ? (
                            <Loader message="Loading dashboard..." />
                        ) : (
                            <>
                                {/*breadcrumb*/}
                                <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                                    {/* <div className="breadcrumb-title pe-3">Contact Us</div> */}
                                    <div className="ps-3">
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb mb-0 p-0">
                                                <li className="breadcrumb-item">
                                                    <a href="#">
                                                        {/* <i className="bx bx-home-alt" /> */}
                                                    </a>
                                                </li>
                                                {/* <li className="breadcrumb-item active" aria-current="page">
                                            Dashboard <h1>(Under Development)</h1>
                                            </li> */}
                                            </ol>
                                        </nav>
                                    </div>

                                </div>
                                {/*end breadcrumb*/}
                                <div className="row">
                                    <div className="col-12 col-lg-4">
                                        <div className="card radius-15 overflow-hidden" onClick={() => navigate('/center')} style={{ cursor: 'pointer' }}>
                                            <div className="card-body" style={{ position: 'relative' }}>
                                                <div className="d-flex">
                                                    <div className="dashborad-icon">
                                                        <img src={center} alt="" />
                                                    </div>
                                                    <div>
                                                        <p className="mb-0 font-weight-bold">Total Centers</p>
                                                        <h2 className="mb-0 h4">{dashboardData?.totalCenters}</h2>
                                                    </div>
                                                    <div className="ms-auto align-self-end">
                                                        {/* <p className="mb-0 font-14 text-primary"><i className="bx bxs-up-arrow-circle" />  <span>1.01% 31 days ago</span>
                                            </p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="card radius-15 overflow-hidden" onClick={() => navigate('/users')} style={{ cursor: 'pointer' }}>
                                            <div className="card-body" style={{ position: 'relative' }}>
                                                <div className="d-flex">
                                                    <div className="dashborad-icon">
                                                        <img src={userIcon} alt="" />
                                                    </div>
                                                    <div>
                                                        <p className="mb-0 font-weight-bold">Total Users</p>
                                                        <h2 className="mb-0 h4">{dashboardData?.totalUsers}</h2>
                                                    </div>
                                                    <div className="ms-auto align-self-end">
                                                        {/* <p className="mb-0 font-14 text-primary"><i className="bx bxs-up-arrow-circle" />  <span>1.01% 31 days ago</span>
                                            </p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="card radius-15 overflow-hidden" onClick={() => navigate('/xray-booking')} style={{ cursor: 'pointer' }}>
                                            <div className="card-body" style={{ position: 'relative' }}>
                                                <div className="d-flex">
                                                    <div className="dashborad-icon">
                                                        <img src={xreyIcon} alt="" />
                                                    </div>
                                                    <div>
                                                        <p className="mb-0 font-weight-bold">Total Bookings</p>
                                                        <h2 className="mb-0 h4">{dashboardData?.totalBookings}</h2>
                                                    </div>
                                                    <div className="ms-auto align-self-end">
                                                        {/* <p className="mb-0 font-14 text-primary"><i className="bx bxs-up-arrow-circle" />  <span>1.01% 31 days ago</span>
                                            </p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="card radius-15 overflow-hidden pd-4" onClick={() => navigate('/operator')} style={{ cursor: 'pointer' }}>
                                            <div className="card-body" style={{ position: 'relative' }}>
                                                <div className="d-flex">
                                                    <div className="dashborad-icon">
                                                        <img src={operatorIcon} alt="" />
                                                    </div>
                                                    <div>
                                                        <p className="mb-0 font-weight-bold">Total Operators</p>
                                                        <h2 className="mb-0 h4">{dashboardData?.totalOperators}</h2>
                                                    </div>
                                                    <div className="ms-auto align-self-end">
                                                        {/* <p className="mb-0 font-14 text-primary"><i className="bx bxs-up-arrow-circle" />  <span>1.01% 31 days ago</span>
                                            </p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-4">
                                        <div className="card radius-15 overflow-hidden pd-4" onClick={() => navigate('/doctor')} style={{ cursor: 'pointer' }}>
                                            <div className="card-body" style={{ position: 'relative' }}>
                                                <div className="d-flex">
                                                    <div className="dashborad-icon">
                                                        <img src={doctorIcon} alt="" />
                                                    </div>
                                                    <div>
                                                        <p className="mb-0 font-weight-bold">Total Radiologists</p>
                                                        <h2 className="mb-0 h4">{dashboardData?.totalRadiologists}</h2>
                                                    </div>
                                                    <div className="ms-auto align-self-end">
                                                        {/* <p className="mb-0 font-14 text-primary"><i className="bx bxs-up-arrow-circle" />  <span>1.01% 31 days ago</span>
                                            </p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-4">
                                        <div className="card radius-15 overflow-hidden pd-4" onClick={() => navigate('/xray-investigation-report')} style={{ cursor: 'pointer' }}>
                                            <div className="card-body" style={{ position: 'relative' }}>
                                                <div className="d-flex">
                                                    <div className="dashborad-icon">
                                                        <img src={xreyIcon} alt="" />
                                                    </div>
                                                    <div>
                                                        <p className="mb-0 font-weight-bold">Total Investigation Reports</p>
                                                        <h2 className="mb-0 h4">{dashboardData?.totalInvestigationReports}</h2>
                                                    </div>
                                                    <div className="ms-auto align-self-end">
                                                        {/* <p className="mb-0 font-14 text-primary"><i className="bx bxs-up-arrow-circle" />  <span>1.01% 31 days ago</span>
                                            </p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>
                        )}

                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Dashboard;